import { render } from "./AuthorizationVk.vue?vue&type=template&id=796111d2"
import script from "./AuthorizationVk.vue?vue&type=script&lang=js"
export * from "./AuthorizationVk.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__